"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _utils = require("../utils");

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * A class to log in the browser.
 */
var BrowserReporter = /*#__PURE__*/function () {
  function BrowserReporter(name) {
    _classCallCheck(this, BrowserReporter);

    this.name = name;
  }

  _createClass(BrowserReporter, [{
    key: "log",
    value: function log(logObj) {
      var _logObj$args$silenced;

      var type = logObj.type;
      var color = (0, _utils.getColor)(type);

      var logArgs = _toConsumableArray(logObj.args); // we need to capture if `silenceConsole` and if its being passed in the object,
      // if its true, we dont want to send anything to the console, defaults to false


      var silencedLogLocation = 0;

      if (_typeof(logObj === null || logObj === void 0 ? void 0 : logObj.args[0]) !== 'object') {
        silencedLogLocation = 1;
      }

      var silenceLogging = (logObj === null || logObj === void 0 ? void 0 : (_logObj$args$silenced = logObj.args[silencedLogLocation]) === null || _logObj$args$silenced === void 0 ? void 0 : _logObj$args$silenced.silenceConsole) || false; // never log anything in the console if `silenceConsole: true`

      if (silenceLogging) {
        return;
      } // Badge for debug mode


      var badge = "%c".concat([this.name]); // Badge style

      var style = "\n      background: ".concat(color, ";\n      border-radius: 0.5em;\n      color: white;\n      font-weight: bold;\n      padding: 2px 0.5em;\n    ");
      var consoleLogFn = console.__log || console.log;

      if (logObj.level <= (0, _utils.getConsolaLevel)('error')) {
        consoleLogFn = console.__error || console.error;
      }

      if (logObj.level === (0, _utils.getConsolaLevel)('warn') && console.warn) {
        consoleLogFn = console.__warn || console.warn;
      } // if we want to always silence the console, we should be able to do so regardless of level type
      // this does not mean it won't make its way to DataDog, we just don't want it on the page


      if (!(0, _utils.shouldLog)(type)) {
        return;
      } // Log without badge if not in debug mode


      if ((0, _utils.currentConsolaLevel)() < (0, _utils.getConsolaLevel)('debug')) {
        consoleLogFn.apply(void 0, _toConsumableArray(logArgs));
        return;
      }

      if (typeof logObj.args[0] === 'string') {
        badge += "%c ".concat(logObj.args[0]); // Insert empty string as style resets to default console style

        logArgs.splice(0, 1, '');
      }

      consoleLogFn.apply(void 0, [badge, style].concat(_toConsumableArray(logArgs)));
    }
  }]);

  return BrowserReporter;
}();

exports["default"] = BrowserReporter;